/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Brian Bal
 */

import React from "react"
import { Route } from "react-router-dom"
import { ProtectedRoute } from "../../components/ProtectedRoute"
import { WrappedSaveMomentFlow } from "../WrappedSaveMomentFlow"
import { PersonalizeMomentPage } from "../PersonalizeMomentPage"
import { WrappedEditMomentPage } from "../WrappedEditMomentPage"
import { WrappedCreateMomentPage } from "../WrappedCreateMomentPage"

export const GamePageRoutes = ({
    token,
    editEnabled,
    createEnabled,
    containerRef,
}) => {
    return (
        <>
            <ProtectedRoute
                path="/:team_name/games/:game_id/:playlist_id/:event_number/create-moment"
                component={WrappedCreateMomentPage}
                isLoggedIn={token?.user_id}
                hasPermissions={createEnabled}
                permissionsLoaded={createEnabled !== null}
                videoContainerRef={containerRef}
                dismissLogin={(history) =>
                    history.push(
                        history.location.pathname.replace("/create-moment", "")
                    )
                }
            />
            <ProtectedRoute
                path="/:team_name/games/:game_id/:playlist_id/:event_number/edit-moment"
                component={WrappedEditMomentPage}
                isLoggedIn={token?.user_id}
                hasPermissions={createEnabled && editEnabled}
                permissionsLoaded={
                    createEnabled !== null && editEnabled !== null
                }
                videoContainerRef={containerRef}
                dismissLogin={(history) =>
                    history.push(
                        history.location.pathname.replace("/edit-moment", "")
                    )
                }
            />
            <Route
                path="/:team_name/games/:game_id/:playlist_id/:event_number/personalize"
                render={(props) => {
                    return (
                        <PersonalizeMomentPage
                            {...props}
                            videoContainerRef={containerRef}
                        />
                    )
                }}
            />
            <ProtectedRoute
                path="/:team_name/games/:game_id/:playlist_id/:event_number/save-moment"
                component={WrappedSaveMomentFlow}
                token={token}
                isLoggedIn={token?.user_id}
                hasPermissions={token?.user_id}
                permissionsLoaded={token !== null}
                dismissLogin={(history) => {
                    history.push(
                        history.location.pathname
                            .replace("/save-moment", "")
                            .replace(/\/start.*$/gi, "")
                    )
                }}
            />
        </>
    )
}
